
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import { customRequestStatusNames } from "@/entities/CustomRequestStatus";

  @Component({
    components: {
      DropdownFilter,
    }
  })
  export default class CustomRequestStatusMultiselect extends Vue {
    @Prop({ type: Array, required: true }) readonly value!: string[];
    @Prop({ type: Array, default: "Select item" }) readonly placeholder!: string;
    @Prop({ type: Boolean, default: true }) readonly multiple!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    chosenStatuses: DropdownOption[] = [];

    get getCustom() {
       const styles = ['customFullWidthInput', this.getcontainerStyle].filter(style => !!style);

    return styles.join(' ');
    }
    get statusOptions(): DropdownOption[] {
      return Object
        .entries(customRequestStatusNames)
        .map(([id, name]) => ({
          id,
          name
        }));
    }

    @Watch('value', {immediate: true})
    updateChosenStatus() {
        this.chosenStatuses =  Object
          .entries(customRequestStatusNames)
          .filter(([id]) => this.value.includes(id))
          .map(([id, name]) => ({id, name}));
    }

    get options(): DropdownOption[] {
      if (!this.multiple) {
        return this.statusOptions;
      }
      return this.statusOptions.filter(option => {
        return !this.value.includes(option.id);
      })
    }

    handleInput(chosenStatuses: DropdownOption[]): void {
      this.chosenStatuses = chosenStatuses;
      this.$emit("input", chosenStatuses.map(option => (option.id)));
    }
  }

